// Generated by purs version 0.14.3
"use strict";
var App_Component_Image = require("../App.Component.Image/index.js");
var App_Model = require("../App.Model/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Void = require("../Data.Void/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Core_Signatures = require("../Network.Ethereum.Core.Signatures/index.js");
var Network_Ethereum_Web3_Solidity_UInt = require("../Network.Ethereum.Web3.Solidity.UInt/index.js");
var Network_Ethereum_Web3_Types_Types = require("../Network.Ethereum.Web3.Types.Types/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var Next = (function () {
    function Next(value0) {
        this.value0 = value0;
    };
    Next.create = function (value0) {
        return new Next(value0);
    };
    return Next;
})();
var SelectUserAddress = (function () {
    function SelectUserAddress(value0) {
        this.value0 = value0;
    };
    SelectUserAddress.create = function (value0) {
        return new SelectUserAddress(value0);
    };
    return SelectUserAddress;
})();
var _tokenImage = Type_Proxy["Proxy"].value;
var assetTransfer = function (dictMonadAff) {
    return function (initialState) {
        var shortenLink = function (str) {
            if (Data_String_CodePoints.length(str) < 20) {
                return str;
            };
            if (Data_Boolean.otherwise) {
                var $$short = Data_String_CodePoints.take(7)(str) + ("..." + Data_String_CodePoints.drop(Data_String_CodePoints.length(str) - 5 | 0)(str));
                return $$short;
            };
            throw new Error("Failed pattern match at App.Component.AssetTransfer (line 114, column 3 - line 116, column 11): " + [ str.constructor.name ]);
        };
        var txLink = function (txHash) {
            return Halogen_HTML_Elements.a([ Halogen_HTML_Properties.href("https://etherscan.io/tx/" + Data_Show.show(Network_Ethereum_Core_HexString.showHexString)(txHash)), Halogen_HTML_Properties.target("_blank") ])([ Halogen_HTML_Core.text(shortenLink(Data_Show.show(Network_Ethereum_Core_HexString.showHexString)(txHash))) ]);
        };
        var renderImage = function (url) {
            return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                return "tokenImage";
            }))(Data_Ord.ordUnit)(_tokenImage)(Data_Unit.unit)(App_Component_Image.imageComponent(dictMonadAff)(App_Model.initialImage(url)))(Data_Unit.unit)(Data_Void.absurd);
        };
        var handleQuery = function (v) {
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
        };
        var $$eval = Halogen_Component.mkEval({
            handleAction: Halogen_Component.defaultEval.handleAction,
            handleQuery: handleQuery,
            receive: Halogen_Component.defaultEval.receive,
            initialize: Halogen_Component.defaultEval.initialize,
            finalize: Halogen_Component.defaultEval.finalize
        });
        var addressLink = function (address) {
            return Halogen_HTML_Elements.a([ Halogen_HTML_Properties.href("https://etherscan.io/address/" + Data_Show.show(Network_Ethereum_Core_Signatures.addressShow)(address)), Halogen_HTML_Properties.target("_blank") ])([ Halogen_HTML_Core.text(Data_Show.show(Network_Ethereum_Core_Signatures.addressShow)(address)) ]);
        };
        var render = function (at) {
            return Halogen_HTML_Elements.li([ Halogen_HTML_Properties.class_("sr-tile") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("sr-pic") ])([ renderImage(at.imageURL) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("sr-info") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("sr-info-headings") ])([ Halogen_HTML_Elements.h6_([ Halogen_HTML_Core.text("to: ") ]), Halogen_HTML_Elements.h6_([ Halogen_HTML_Core.text("from: ") ]), Halogen_HTML_Elements.h6_([ Halogen_HTML_Core.text("tokenId: ") ]), Halogen_HTML_Elements.h6_([ Halogen_HTML_Core.text("transactionHash: ") ]), Halogen_HTML_Elements.h6_([ Halogen_HTML_Core.text("blockNumber: ") ]) ]), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("sr-info-details") ])([ Halogen_HTML_Elements.h5([ Halogen_HTML_Properties.class_("user-address-link"), Halogen_HTML_Events.onClick(Data_Function["const"](new SelectUserAddress(at.to))) ])([ addressLink(at.to) ]), Halogen_HTML_Elements.h5([ Halogen_HTML_Properties.class_("user-address-link"), Halogen_HTML_Events.onClick(Data_Function["const"](new SelectUserAddress(at.from))) ])([ addressLink(at.from) ]), Halogen_HTML_Elements.h5_([ Halogen_HTML_Core.text(Data_Show.show(Network_Ethereum_Web3_Solidity_UInt.showUIntN)(at.tokenId)) ]), Halogen_HTML_Elements.h5_([ txLink(at.transactionHash) ]), Halogen_HTML_Elements.h5_([ Halogen_HTML_Core.text(Data_Show.show(Network_Ethereum_Web3_Types_Types.showBlockNumber)(at.blockNumber)) ]) ]) ]) ]);
        };
        return Halogen_Component.mkComponent({
            initialState: Data_Function["const"](initialState),
            render: render,
            "eval": $$eval
        });
    };
};
module.exports = {
    Next: Next,
    SelectUserAddress: SelectUserAddress,
    "_tokenImage": _tokenImage,
    assetTransfer: assetTransfer
};
